export default {
  eventListPage: {
    city: {
      cityCategoryHorizontalListTitle:
        'Workshops und Kurse in {city} entdecken',
    },
    teamEventSlugPrefix: 'teamevent',
    kitsTitle: '{category} für zu Hause',
  },
}
